/**
 * 专业/班级模块接口列表
 */

import base from '../base' // 导入接口域名列表
import axios from '../../request/http' // 导入http中创建的axios实例

const stepsApi = {
  GetDataList: `${base.qa}/MedicineExperimentsteps/GetDataList`,
  SaveSpecialty: `${base.qa}/Organization/SaveSpecialty`, //添加修改专业
  GetOrganizationInfo: `${base.qa}/Organization/GetOrganizationInfo`, //根据id查询信息
  DelData: `${base.qa}/MedicineExperimentsteps/DelData`, //删除

  GetClassList: `${base.qa}/Organization/GetClassList`,
  GetOrgDataTree: `${base.qa}/Organization/GetOrgDataTree`, //获取专业班级树形图
  SaveData: `${base.qa}/MedicineExperimentsteps/SaveData` //修改班级
}

const steps = {
  GetDataList(params) {
    return axios.get(stepsApi.GetDataList, { params })
  },
  SaveSpecialty(params) {
    return axios.post(organizationApi.SaveSpecialty, params)
  },
  GetOrganizationInfo(orgid) {
    return axios.get(organizationApi.GetOrganizationInfo, { params: { orgid } })
  },
  DelData(params) {
    return axios.post(stepsApi.DelData, params)
  },
  GetClassList(specialtyid) {
    return axios.get(organizationApi.GetClassList, { params: { specialtyid, ispage: false } })
  },
  GetOrgDataTree() {
    return axios.get(organizationApi.GetOrgDataTree)
  },
  SaveData(params) {
    return axios.post(stepsApi.SaveData, params)
  }
}

export default steps

